import { render, staticRenderFns } from "./UnassignedArticles.vue?vue&type=template&id=ab65c976"
import script from "./UnassignedArticles.vue?vue&type=script&lang=js"
export * from "./UnassignedArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports